"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Org/ConsentTab/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _useEntityPreload = require('shared/hooks/useEntityPreload'); var _useEntityPreload2 = _interopRequireDefault(_useEntityPreload);
var _consent = require('shared/services/consent');
var _noticeBar = require('web/services/context/noticeBar');

var _Org = require('web/components/Settings/Org');
var _Form = require('web/components/Form');
var _TurnOnModal = require('./TurnOnModal'); var _TurnOnModal2 = _interopRequireDefault(_TurnOnModal);
var _TurnOffModal = require('./TurnOffModal'); var _TurnOffModal2 = _interopRequireDefault(_TurnOffModal);







// Org admins in orgs with the CONSENT bit: the "Require consent before
// texting" switch, who turned it on, the texts contacts get, and the
// history export. The server refuses every command for anyone else.
const ConsentTab = ({ orgKey }) => {
  const [setting, setSetting] = _react.useState(null)
  const [dialog, setDialog] = _react.useState(null)
  const [isExporting, setIsExporting] = _react.useState.call(void 0, false)
  const { showSuccessBar, showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )

  const load = _react.useCallback.call(void 0, 
    () => _actions2.default.getOrgConsent({ OrgKey: orgKey }).then(setSetting),
    [orgKey],
  )
  const hasLoadFailed = _useEntityPreload2.default.call(void 0, load)

  // The switch only opens a dialog; the setting changes once the server says so.
  const onToggle = _react.useCallback.call(void 0, (on) => setDialog(on ? 'on' : 'off'), [])
  const onCloseDialog = _react.useCallback.call(void 0, () => setDialog(null), [])

  const onTurnedOn = _react.useCallback.call(void 0, (view) => {
    setSetting(view)
    setDialog(null)
    showSuccessBar('Consent is now required before texting')
  }, [showSuccessBar])

  const onTurnedOff = _react.useCallback.call(void 0, ({ Consent, Released }) => {
    setSetting(Consent)
    setDialog(null)
    showSuccessBar(Released
      ? `Consent is no longer required. ${Released} waiting ${Released === 1 ? 'message' : 'messages'} sent.`
      : 'Consent is no longer required')
  }, [showSuccessBar])

  const onExport = _react.useCallback.call(void 0, () => {
    setIsExporting(true)
    _actions2.default.getOrgConsentHistoryURL({ OrgKey: orgKey })
      .then(url => { window.open(url, '_self') })
      .catch(() => showWarningBar('Failed to export consent history'))
      .finally(() => setIsExporting(false))
  }, [orgKey, showWarningBar])

  const titleId = _react.useId.call(void 0, )
  const textsTitleId = _react.useId.call(void 0, )

  const onSince = setting ? _consent.consentOnSinceCopy.call(void 0, setting) : ''
  const attestation = setting ? _consent.consentAttestationCopy.call(void 0, setting) : ''

  return (
    _react2.default.createElement(_Org.TabWrapper, { classNameSuffix: "consent", __self: this, __source: {fileName: _jsxFileName, lineNumber: 69}}
      , _react2.default.createElement('section', { className: "settings--org-consent--section", 'aria-labelledby': titleId, __self: this, __source: {fileName: _jsxFileName, lineNumber: 70}}
        , _react2.default.createElement('h3', { id: titleId, className: "settings--org-consent--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 71}}, "Consent to text"  )
        ,  hasLoadFailed && (
          _react2.default.createElement('span', { role: "alert", className: "settings--org-consent--error", __self: this, __source: {fileName: _jsxFileName, lineNumber: 73}}, "Couldn't load this setting. Reload the page to try again."

          )
        )
        ,  setting && (
          _react2.default.createElement(_react2.default.Fragment, null
            , _react2.default.createElement(_Form.Toggle, {
              className: "settings--org-consent--toggle",
              label: "Require consent before texting"   ,
              isChecked: setting.Required,
              onChange: onToggle, __self: this, __source: {fileName: _jsxFileName, lineNumber: 79}}
            )
            , _react2.default.createElement('span', { className: "settings--org-consent--hint", __self: this, __source: {fileName: _jsxFileName, lineNumber: 85}}, "When this is on, BloomText asks each contact for consent before your team's first text, and holds your messages until they reply YES. Campaigns and imports work as usual. A contact who texts you first counts as consented."



            )
            ,  !!onSince && _react2.default.createElement('span', { className: "settings--org-consent--on-since", __self: this, __source: {fileName: _jsxFileName, lineNumber: 90}},  onSince ) 
            ,  !!attestation && _react2.default.createElement('span', { className: "settings--org-consent--attestation", __self: this, __source: {fileName: _jsxFileName, lineNumber: 91}},  attestation ) 
          )
        )
      )
      ,  setting && (
        _react2.default.createElement('section', { className: "settings--org-consent--section settings--org-consent--texts" , 'aria-labelledby': textsTitleId, __self: this, __source: {fileName: _jsxFileName, lineNumber: 96}}
          , _react2.default.createElement('h3', { id: textsTitleId, className: "settings--org-consent--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 97}}, "What contacts get"  )
          , _react2.default.createElement('span', { className: "settings--org-consent--hint", __self: this, __source: {fileName: _jsxFileName, lineNumber: 98}}, "These texts start with your organization's name, name the team that's texting, and can't be edited. The example uses one of your teams. For a secure chat, the request says \"a secure message\"."



          )
          , _react2.default.createElement('figure', { className: "settings--org-consent--text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 103}}
            , _react2.default.createElement('figcaption', { className: "settings--org-consent--text-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 104}}, "Consent request" )
            , _react2.default.createElement('p', { className: "settings--org-consent--bubble", __self: this, __source: {fileName: _jsxFileName, lineNumber: 105}},  setting.RequestText )
          )
          , _react2.default.createElement('figure', { className: "settings--org-consent--text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 107}}
            , _react2.default.createElement('figcaption', { className: "settings--org-consent--text-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 108}}, "Confirmation · after they reply YES"     )
            , _react2.default.createElement('p', { className: "settings--org-consent--bubble", __self: this, __source: {fileName: _jsxFileName, lineNumber: 109}},  setting.ConfirmationText )
          )
          , _react2.default.createElement('span', { className: "settings--org-consent--note", __self: this, __source: {fileName: _jsxFileName, lineNumber: 111}}, "With keywords on, a team that turns on \"Mention keywords in the welcome text\" gets its keywords in the confirmation, before the rates line. A family's first text to your number also gets your contact card. When that text is their YES, the card comes after the confirmation."




          )
        )
      )
      ,  setting && (
        _react2.default.createElement('section', { className: "settings--org-consent--section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 120}}
          , _react2.default.createElement(_Form.Button, { isOutlined: true, isLoading: isExporting, isDisabled: isExporting, onClick: onExport, __self: this, __source: {fileName: _jsxFileName, lineNumber: 121}}, "Export CSV"

          )
          , _react2.default.createElement('span', { className: "settings--org-consent--hint", __self: this, __source: {fileName: _jsxFileName, lineNumber: 124}}, "Every consent request, reply, recorded consent and opt-out, for your records."

          )
        )
      )
      , _react2.default.createElement(_TurnOnModal2.default, {
        isOpen: dialog === 'on',
        orgKey: orgKey,
        onClose: onCloseDialog,
        onTurnedOn: onTurnedOn, __self: this, __source: {fileName: _jsxFileName, lineNumber: 129}}
      )
      , _react2.default.createElement(_TurnOffModal2.default, {
        isOpen: dialog === 'off',
        orgKey: orgKey,
        onClose: onCloseDialog,
        onTurnedOff: onTurnedOff, __self: this, __source: {fileName: _jsxFileName, lineNumber: 135}}
      )
    )
  )
}

exports. default = _react.memo.call(void 0, ConsentTab)
